<argos-ng-spinner [isFixed]="true" [isLoading]="isLoading">
  <ng-template argosAlertHost></ng-template>
  <header [class.root-display-none]="!showHeader">
    <my-account-header (logout)="logout()"></my-account-header>
  </header>
  <main>
    <router-outlet></router-outlet>
    <ng-template argosModalHost></ng-template>
  </main>
  <footer [class.root-display-none]="!showFooter">
    <my-account-footer></my-account-footer>
  </footer>
</argos-ng-spinner>
